<template>
  <div>
    <v-autocomplete
      id="blockchain_key_import_option"
      :label="$tc('select_option')"
      :items="keyImportOptions"
      item-text="name"
      item-value="value"
      v-model="keyImportOption"
      :readonly="publicKeyExportAction"
    />

    <blockchain-private-key
      v-if="isPrivateKey"
      :key-name="keyName"
      :key-info="keyInfo"
    />

    <blockchain-public-key
      v-if="isPublicKey"
      :name="keyName"
      :key-info="keyInfo"
    />
  </div>
</template>

<script>
import BlockchainPrivateKey from './BlockchainPrivateKey.vue'
import BlockchainPublicKey from './BlockchainPublicKey.vue'

export default {
  emits: ['close'],
  components: {
    BlockchainPrivateKey,
    BlockchainPublicKey
  },
  props: {
    keyName: {
      type: String,
      required: true,
      default: null
    },
    keyInfo: {
      type: Object,
      required: true,
      default: null
    },
    keyOption: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      keyImportOption: 0,
      publicKeyExportAction: false
    }
  },
  created () {
    this.keyImportOption = this.keyOption
    this.publicKeyExportAction = this.keyOption !== 0
  },
  computed: {
    isPrivateKey () {
      return this.keyImportOption === 2
    },
    isPublicKey () {
      return this.keyImportOption === 1
    },
    keyImportOptions () {
      return [
        {
          name: 'Public key',
          value: 1
        },
        {
          name: 'Private Key',
          value: 2
        }
      ]
    }
  },
  methods: { }
}
</script>
